import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class ConsummableService {

    constructor(private dataService: DataService) {
    };

    get(refresh: Boolean) {
        return this.dataService.getData('/api/spareconsumable', refresh);
    }

    getLookUp(data: any, refresh: Boolean) {
        return this.dataService.getDataWithParams('/api/serviceschedule/lookup/', data, refresh);
    }
    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/spareconsumable/' + id, refresh);
    }

    delete(id: number) {
        return this.dataService.delete('/api/spareconsumable/' + id).map(response => {
            this.dataService.clearCache();
            // this.dataService.clearRouteCache(this.route);
            return response;
        });
    }

    save(data: any) {
        return this.dataService.post('/api/spareconsumable', data).map(response => {
            return response;
        });
    }

    getUomType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/uomtype', refresh);
    }

    getItemType(refresh: boolean) {
        return this.dataService.getData('/api/lookup/itemtype', refresh);
    }

    getQuantitytype(refresh: boolean) {
        return this.dataService.getData('/api/lookup/quantitytype', refresh);
    }

    //consumable log section
    consumablelogSave(data: any) {
        return this.dataService.post('/api/spareconsumablelog', data).map(response => {
            return response;
        });
    }

    getconsumablelogById(id: number, refresh: boolean) {
        //  return this.dataService.getRecord('/api/spareconsumable/' + id);
        return this.dataService.getData('/api/spareconsumablelog/' + id, refresh);
    }

    getconsumableslog(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/spareconsumablelog/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.financialYearId, refresh);
    }

    getbyQId(data: any, refresh: Boolean) {
        return this.dataService.getData('/api/spareconsumablelog/logs/' + data.vehicleId + '/' + data.startts, refresh);
    }

    deleteConsumable(id: number) {
        return this.dataService.delete('/api/spareconsumablelog/' + id).map(response => {
            // this.dataService.clearCache();
            return response;
        });
    }

}
